/* eslint-disable import/no-unresolved */
// Import SVG assets
import fanSvg from './sprites/home/fan.svg';
import doorSvg from './sprites/home/door.svg';
import smartLightSvg from './sprites/home/smart-light.svg';
import carSvg from './sprites/city/car.svg';
import buildingSvg from './sprites/city/building.svg';
import trafficLightSvg from './sprites/city/traffic-light.svg';
/* eslint-enable import/no-unresolved */

/**
 * Generate a simple hash for asset IDs (using name-based hash)
 * @param {string} str - The string to hash
 * @returns {string} A 32-character hexadecimal hash string
 */
const simpleHash = str => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return Math.abs(hash)
        .toString(16)
        .padStart(32, '0')
        .substring(0, 32);
};

const customSprites = [
    {
        name: 'Fan',
        tags: ['home'],
        isStage: false,
        variables: {},
        rawURL: fanSvg, // Set at sprite level for library display
        costumes: [
            {
                assetId: simpleHash('fan-costume'),
                name: 'fan',
                bitmapResolution: 1,
                md5ext: `${simpleHash('fan-costume')}.svg`,
                dataFormat: 'svg',
                rotationCenterX: 50,
                rotationCenterY: 50,
                rawURL: fanSvg
            }
        ],
        sounds: [],
        blocks: {}
    },
    {
        name: 'Door',
        tags: ['home'],
        isStage: false,
        variables: {},
        rawURL: doorSvg, // Set at sprite level for library display
        costumes: [
            {
                assetId: simpleHash('door-costume'),
                name: 'door',
                bitmapResolution: 1,
                md5ext: `${simpleHash('door-costume')}.svg`,
                dataFormat: 'svg',
                rotationCenterX: 50,
                rotationCenterY: 55,
                rawURL: doorSvg
            }
        ],
        sounds: [],
        blocks: {}
    },
    {
        name: 'Smart Light',
        tags: ['home'],
        isStage: false,
        variables: {},
        rawURL: smartLightSvg, // Set at sprite level for library display
        costumes: [
            {
                assetId: simpleHash('smart-light-costume'),
                name: 'smart-light',
                bitmapResolution: 1,
                md5ext: `${simpleHash('smart-light-costume')}.svg`,
                dataFormat: 'svg',
                rotationCenterX: 50,
                rotationCenterY: 50,
                rawURL: smartLightSvg
            }
        ],
        sounds: [],
        blocks: {}
    },
    {
        name: 'Car',
        tags: ['city'],
        isStage: false,
        variables: {},
        rawURL: carSvg, // Set at sprite level for library display
        costumes: [
            {
                assetId: simpleHash('car-costume'),
                name: 'car',
                bitmapResolution: 1,
                md5ext: `${simpleHash('car-costume')}.svg`,
                dataFormat: 'svg',
                rotationCenterX: 50,
                rotationCenterY: 75,
                rawURL: carSvg
            }
        ],
        sounds: [],
        blocks: {}
    },
    {
        name: 'Building',
        tags: ['city'],
        isStage: false,
        variables: {},
        rawURL: buildingSvg, // Set at sprite level for library display
        costumes: [
            {
                assetId: simpleHash('building-costume'),
                name: 'building',
                bitmapResolution: 1,
                md5ext: `${simpleHash('building-costume')}.svg`,
                dataFormat: 'svg',
                rotationCenterX: 50,
                rotationCenterY: 60,
                rawURL: buildingSvg
            }
        ],
        sounds: [],
        blocks: {}
    },
    {
        name: 'Traffic Light',
        tags: ['city'],
        isStage: false,
        variables: {},
        rawURL: trafficLightSvg, // Set at sprite level for library display
        costumes: [
            {
                assetId: simpleHash('traffic-light-costume'),
                name: 'traffic-light',
                bitmapResolution: 1,
                md5ext: `${simpleHash('traffic-light-costume')}.svg`,
                dataFormat: 'svg',
                rotationCenterX: 50,
                rotationCenterY: 50,
                rawURL: trafficLightSvg
            }
        ],
        sounds: [],
        blocks: {}
    }
];

export default customSprites;
